var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))]),_c('div',{staticClass:"details",domProps:{"innerHTML":_vm._s(_vm.details)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }